"use strict";
// @ts-ignore
try {
    self['workbox:background-sync:7.1.0'] && _();
}
catch (e) { }
